export function isUserProfileEssentialsCompleted(userInfo) {
  if (!userInfo) return false;

  return !!(userInfo.displaylocation && userInfo.firstname && userInfo.surname);
}
